import {
  ViewerPage, PrivacyPolicyPage, TermsOfUsePage,
  FeedbackPage,
  Share,
  TestCasePage,
} from '../pages/index';


export default [
  { path: '/', name: 'ViewerPage', component: ViewerPage, auth: false },
  // 添加一个企业账户共享协作进去的路由，重定向到主页
  { path: '/cloudShare', name: 'CloudShare', component: ViewerPage, auth: false },
  { path: '/open-pdf', name: 'ViewerPage', component: ViewerPage, auth: false },
  { path: '/feedback', name: 'FeedbackPage', component: (FeedbackPage), auth: true },
  { path: '/download-share', name: 'Share', component: (Share), auth: true },
  { path: '/privacy-policy', name: 'PrivacyPolicyPage', component: (PrivacyPolicyPage), auth: false },
  { path: '/term-of-use', name: 'TermsOfUsePage', component: (TermsOfUsePage), auth: false },
  { path: '/terms-of-service', name: 'TermsOfService', component: (TermsOfUsePage), auth: false },
  { path: '/test-case', name: 'TestCasePage', component: (TestCasePage), auth: false },
  { path: '/redeem', name: 'Redeem', component: ViewerPage, auth: false },
];
